import { httpV1 as http } from '../api';

export async function getImages(params) {
  return http
    .get('/anti-fraud', { params })
    .then(({ data }) => data);
}

export async function getImagesCorban(params) {
  return http
    .get('/anti-fraud/corban', { params })
    .then(({ data }) => data);
}

export async function checkApproval(params) {
  return http
    .get('/anti-fraud/approve', { params })
    .then(({ data }) => data);
}

export async function resolution(data) {
  return http
    .put('/anti-fraud/resolution', data)
    .then(({ data: _data }) => _data);
}

export async function checkRFB(data) {
  return http.post('/anti-fraud/rfb', data);
}

export async function refusal(params) {
  return http.get('/anti-fraud/refusal', { params });
}

export async function deleteDetails(antifraud_id, account_id, proposal_id) {
  return http.delete(`/anti-fraud/${antifraud_id}/details?account_id=${account_id}&proposal_id=${proposal_id}`);
}

export async function issue(proposal_id, data) {
  return http.put(`/proposals/${proposal_id}/issue-type`, data);
}

export async function createVideoCallRoom(data) {
  return http.post('/anti-fraud/video-calls', data);
}

export async function fulfillmentVideoCall(data) {
  return http.put('/anti-fraud/video-calls/fulfillment', data);
}

export async function recordingUrl(params) {
  return http.get('/anti-fraud/video-calls/recording-url', { params });
}

export async function getDataByDocument({ document, ...params }) {
  return http.get(`/anti-fraud/get-data-by-document?document=${document}`, { params });
}
